
const digest = 'dbeb61a3131a618567aab752c27ca1cc6f71b1f8fe5305aec5a5e333a88f8899';
const classes = {"errorMessage":"_errorMessage_p33nn_1"};
const css = `._errorMessage_p33nn_1 {
  font-family: Rubik, "sans-serif";
  font-size: 14px;
  color: #d81616;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  